class PageScroll {
    constructor() {
        this.threshold = 300;

        this.init();
    }

    init() {
        window.addEventListener('scroll', () => {
            if( window.scrollY > this.threshold ) {
                document.body.classList.add('scrolled');
            } else {
                document.body.classList.remove('scrolled');
            }
        });
    }
}

new PageScroll();